import { render, staticRenderFns } from "./roleRightsDialog.vue?vue&type=template&id=2034c2da&"
import script from "./roleRightsDialog.vue?vue&type=script&lang=js&"
export * from "./roleRightsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports